module.exports = __webpack_public_path__ + "img/receita-federal.298f002b.svg";